import { createContext } from "react";

export const AutomaticSummarizationContext = createContext();
